// autocomplete.js

// Definiere die Autocomplete-Klasse
class Autocomplete {
  constructor(inputElement, options) {
    this.inputElement = inputElement;
    this.options = options;

    // Füge Event-Listener für die Eingabe hinzu
    this.inputElement.addEventListener('input', this.handleInput.bind(this));

    // Erstelle die Liste für die Vorschläge
    this.createSuggestionsList();
  }

  handleInput() {
    const inputValue = this.inputElement.value.toLowerCase();

    // Filtere die Vorschläge basierend auf der Eingabe
    const filteredSuggestions = this.options.data.src.filter(
      suggestion => suggestion.toLowerCase().includes(inputValue)
    );

    // Zeige die gefilterten Vorschläge an
    this.updateSuggestionsList(filteredSuggestions);
  }

  createSuggestionsList() {
    this.suggestionsList = document.createElement('ul');
    this.suggestionsList.classList.add('autocomplete-suggestions');
    document.body.appendChild(this.suggestionsList);

    // Verberge die Vorschläge initial
    this.suggestionsList.style.display = 'none';

    // Füge Event-Listener für den Klick auf einen Vorschlag hinzu
    this.suggestionsList.addEventListener('click', this.handleSuggestionClick.bind(this));
  }

  updateSuggestionsList(suggestions) {
    // Lösche vorhandene Vorschläge
    while (this.suggestionsList.firstChild) {
      this.suggestionsList.removeChild(this.suggestionsList.firstChild);
    }

    // Füge neue Vorschläge hinzu
    suggestions.forEach(suggestion => {
      const listItem = document.createElement('li');
      listItem.textContent = suggestion;
      this.suggestionsList.appendChild(listItem);
    });

    // Zeige die Vorschläge an, wenn welche vorhanden sind
    this.suggestionsList.style.display = suggestions.length > 0 ? 'block' : 'none';
  }

  handleSuggestionClick(event) {
    // Setze den ausgewählten Vorschlag als Wert des Eingabefelds
    if (event.target.tagName === 'LI') {
      this.inputElement.value = event.target.textContent;
      this.suggestionsList.style.display = 'none';
    }
  }
}

// Beispiel-Konfiguration
const zipCodes = ['10115', '20095', '80331', /* ... Weitere PLZ ... */];

// Autocomplete-Initialisierung für die PLZ
const zipCodeInput = document.getElementById('ContactForm-zipcode');
new Autocomplete(zipCodeInput, {
  data: {
    src: zipCodes
  }
});

